import { ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { SortDefinition } from '../../../sort/models/sort-definition.model';
import { DataFilterManagerService, FilterDefinitionStoreService } from '../../services';

@Component({
  selector: 'app-sort-dropdown',
  templateUrl: './sort-dropdown.component.html',
  styleUrls: ['./sort-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortDropdownComponent implements OnInit {
  /** Filter instance id to link this dropdown to */
  @Input()
  filterInstanceId: string;

  options$: Observable<SortDefinition<any>[]>;
  selectedOption$: Observable<SortDefinition<any>>;

  @Output()
  sortOptionChanged = new EventEmitter<string>();

  constructor(
    public filterDefinitionStoreService: FilterDefinitionStoreService,
    public dataFilterManagerService: DataFilterManagerService
  ) {}

  ngOnInit(): void {
    const filterConfig$ = this.filterDefinitionStoreService.get(this.filterInstanceId).pipe(
      filter((config) => !!config),
      shareReplay({ bufferSize: 1, refCount: true })
    );
    this.options$ = filterConfig$.pipe(map((filterConfig) => filterConfig.sortDefinition));

    this.selectedOption$ = filterConfig$.pipe(
      switchMap((filterConfig) =>
        this.dataFilterManagerService.getSortOptionId(filterConfig.filterInstanceId).pipe(
          filter((selectedOptionId) => !!selectedOptionId),
          map((selectedOptionId) => filterConfig.sortDefinition.find((sortDef) => sortDef.id === selectedOptionId))
        )
      )
    );
  }

  changeSortOption(sortDef: SortDefinition<any>): void {
    if (!sortDef) {
      return;
    }

    this.dataFilterManagerService.changeSortOption(this.filterInstanceId, sortDef.id);
    this.sortOptionChanged.emit(sortDef.id);
  }

  selectDisplayValue(sortDef: SortDefinition<any>): string {
    return sortDef.translationKey;
  }
}
